module.exports = __webpack_public_path__ + "img/beer_id-61.af47ce9b.png";